import { render } from "./searchChat.vue?vue&type=template&id=116238e1"
import script from "./searchChat.vue?vue&type=script&lang=js"
export * from "./searchChat.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__